<template>
  <svg
    :width="width ? width : height ? height : 40"
    :height="height ? height : width ? width : 40"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M26.67 13.33H4.44V4.44h22.23v8.9zM20 35.56a6.67 6.67 0 1 1 0-13.34 6.67 6.67 0 0 1 0 13.34zM31.11 0H4.44C1.98 0 0 2 0 4.44v31.12A4.44 4.44 0 0 0 4.44 40h31.12A4.44 4.44 0 0 0 40 35.56V8.89L31.11 0z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'save',
  props: {
    iconColor: {
      type: String,
      default: '#FFFFFF',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
